/**
 * Unit conversion for the decal editor. Scene coordinates are pixels at this DPI,
 * which is also the space object left/top and the print output live in.
 */
export const DPI = 96;
const MM_PER_INCH = 25.4;
export const mmToPixels = (mm) => (mm / MM_PER_INCH) * DPI;
export const pixelsToMM = (pixels) => (pixels * MM_PER_INCH) / DPI;
